<div class="video-container">
    <video id="ivsPlayer" class="video-js vjs-16-9 vjs-big-play-centered" controls autoplay playsinline></video>
    <button *ngIf="error === true" class="btn btn-primary" (click)="refresh()">Reload Stream</button>
</div>